import { render, staticRenderFns } from "./AppEditableHeader.vue?vue&type=template&id=1ade53c0&scoped=true&"
import script from "./AppEditableHeader.vue?vue&type=script&lang=ts&"
export * from "./AppEditableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppEditableHeader.vue?vue&type=style&index=0&id=1ade53c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade53c0",
  null
  
)

export default component.exports